import { useState } from 'react';
import { CategoryFilterStyled, FilterList } from './styled';
import { fireFilterEvent } from '../../TopicListing/common';

export default function CategoryFilter(props) {
  const { filterCategories, filterCategoryName, section_name, section_id } =
    props;
  const [active, setActive] = useState(filterCategoryName[0]);
  return (
    <CategoryFilterStyled>
      {filterCategoryName?.map((curElem, index) => {
        return (
          <FilterList
            key={`filterList${index}`}
            onClick={() => {
              filterCategories(curElem);
              fireFilterEvent(curElem, section_name, section_id);
              setActive(curElem);
            }}
            className={active === curElem && 'active'}
          >
            {curElem}
          </FilterList>
        );
      })}
    </CategoryFilterStyled>
  );
}
